// Module
var code = `<div ng-if="\$ctrl.blockAction" class="alert alert--danger">
  <span>
    Please wait for initial cash transfer from cashier to unlock further operations.
  </span>
</div>

<div ng-if="!\$ctrl.blockActions">
  <!-- State 0: working day status is STARTED -> allow actions -->
  <!-- No extra elements to be rendered -->

  <!-- State 1: working day status is COUNTER_CLOSED -> display warning but allow actions -->
  <!-- State 2: working day status is PENDING & user has permissions to start the day -> display warning but allow actions -->
  <div class="alert alert--danger"
       ng-if="['COUNTER_CLOSED', 'PENDING', 'START_DAY_PROCESSING'].includes(\$ctrl.workingDayStatus)">
      <span>
        Working day is not started and most actions may be unavailable. Current working day status is: {{\$ctrl.workingDayStatus | prettyEnum}}
      </span>
  </div>

  <!-- State 3: working day status is PENDING & user has no permission to start the day -->
  <!-- State 4: working day status is CLOSED or END_DAY_PROCESSING -> lock screen and not allow ANY actions -->
  <div class="working-day-overlay"
       ng-if="(\$ctrl.workingDayLocked || \$ctrl.workingDayStatus === 'PENDING' && !\$ctrl.startDayAvailable) && !\$ctrl.isUserTechnical">
    <div class="message-container-wrapper">
      <div class="message-container">
        <div class="message-container">
          <div>Working day for your branch is closed. Please wait until branch is started.</div>
          <i class="icon-off" ng-click="\$ctrl.logout()"></i>
        </div>
      </div>
    </div>
    <no-scroll></no-scroll>
  </div>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/technical/working-day-check/working-day-check.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;